import { createAuthClient } from 'better-auth/react'
import { inferAdditionalFields } from 'better-auth/client/plugins'
// Solo le costanti (senza zod): questo modulo è nel bundle di ogni pagina pubblica (header).
import { API_ROUTES } from '@sepma/shared/constants'

// Stesso origin del sito (proxy Vite in dev, Worker o nginx in produzione): endpoint sotto /api/auth.
// I campi aggiuntivi rispecchiano `user.additionalFields` in apps/backend/src/auth.ts.
export const authClient = createAuthClient({
  // Al prerender (Node) non c'è window: un'origine fittizia evita l'errore di inizializzazione; nel browser è quella reale.
  baseURL: typeof window === 'undefined' ? 'http://localhost' : window.location.origin,
  basePath: API_ROUTES.auth,
  plugins: [
    inferAdditionalFields({
      user: {
        firstName: { type: 'string', required: false },
        lastName: { type: 'string', required: false },
        enabled: { type: 'boolean', required: true, input: false },
        ordering: { type: 'number', required: true, input: false },
        // Fuso IANA dell'area riservata (null = Europe/Rome): lo cambia l'utente con `updateUser`, vedi lib/time-zone.ts.
        timeZone: { type: 'string', required: false },
      },
    }),
  ],
})

export const { useSession, signIn, signOut, requestPasswordReset, resetPassword, changePassword, updateUser } = authClient
